<template>
	<div>
		<div class="sousuo" style="width: 100%">
			<div style="width: 550px" class="yl-flex flex_between">
				<Input placeholder="搜索表单名称" v-model="name" style="width: 300px">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
				<Button  style="margin-left: 20px;" type="primary" @click="addFormButton">添加表单格式</Button>
			</div>
		</div>
		<div class="multiple">
			<div class="child-div">创建时间</div>
			<RadioGroup v-model="timePeriod">
				<Radio label="0"><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
					placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
		<div style="width: 100% ;margin-top: 20px;">
			<Table stripe border :columns="columns" :data="datas" ref="table">
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id" :data-index="index"
						@click="editFormType">编辑</Button>
					<Button type="error" size="small" :data-id="row.id" @click="delFormType">删除</Button>
				</template>
				<template slot-scope="{row, index}" slot="status" >
					<i-switch v-model="datas[index].status" @on-change="saveOpen($event, index)">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</template>
			</Table>
		</div>
		<!-- 表单样式 -->
		<Modal v-model="form_modal" width="500" title="添加表单格式">
			<Form :label-width="120">
				<FormItem label="表单名称">
					<Input placeholder="表单名称" v-model="pageForm.form_name"></Input>
				</FormItem>
				<FormItem label="样式图">
					<MyUpload :onlyRead="false" ref="form_picture"></MyUpload>
				</FormItem>
				<FormItem label="状态">
					<i-switch v-model="pageForm.status">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</FormItem>
				<FormItem label="备注">
					<Input placeholder="备注" v-model="pageForm.remark"></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addFormType">提交</Button>
				<Button type="default" @click="form_modal = false">取消</Button>
			</div>
		</Modal>		
	</div>
</template>
<script>
	import MyUpload from '../../tool/AdvUpload.vue'
	import {
		mapGetters
	} from "vuex";
	import {
		getAllMediumCode,
		getAccountStatic,
		getAllAccountList,
		getFormTypeList,
		getFormType,
		getAllOperater,
		getToutiaoSrc,
		addFormType,
		getCidTypeList,
		saveAccountStatusOpen,
		delFormType
	} from "../../../api/advManage";
	import CreateCost from "./CreateCost.vue"; //排行榜

	export default {
		name: "AccountStatic",
		props: ['clickTabValue'],
		components: {
			MyUpload,
			CreateCost
		},
		data() {
			return {
				modal: false,
				form_modal:false,
				name: '',
				timePeriod: '0',
				timePeriodDate: [],
				datas: [],
				operaterList:[],
				srcList:[],
				cidTypeList:[],
				uid:[],
				pageForm: {
					url:'',
				},
				CreateCostModal: false,
				columns: [{
						"title": "序号",
						"key": "id",
						"align": "center",
						"fixed": 'left'
					},
					{
						"title": "账户名称",
						"key": "form_name",
						"align": "center",
						"fixed": 'left'
					},
					{
						"title": "状态",
						"slot": "status",
						"align": "center",
					},
					{
						title: 'Action',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();
			this.getList();
		},
		methods: {
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.timePeriod = 0;
				this.timePeriodDate = [];
				this.uid = [];
				this.search();
			},
			createCost() {
				this.CreateCostModal = true;
			},
			async loadData() {
				let that = this;
				 let data = {}
				 data.token = this.token;
				 let res = await getAllOperater(that, data);
				 that.operaterList = res.data.list;
				 res = await getToutiaoSrc(that, data);
				 that.srcList = res.data.list;
				 res = await getCidTypeList(that, data);
				 that.cidTypeList = res.data.list;
			},
			saveOpen(e, index) {
				console.log(e)
				let item = this.datas[index];
				let that = this;
				let data = {
					token: this.token,
					id: item.id,
					status: item.status
				};
				this.throttle(async function() {
					let res = await saveAccountStatusOpen(that, data);
					if (res.code == 1) {
						that.$Message.success('操作成功');
					}
				}, 200)
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getFormTypeList(that, data);
				that.datas = res.data.list;
			},
			// 编辑账户
			async editFormType(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id,
				};
				let res = await getFormType(that, data);
				console.log(res)
				if (res.code == 1) {
					if(res.data.item.form_picture != null && res.data.item.form_picture !== undefined  && res.data.item.form_picture !== ""){
						var jsonStr = JSON.parse(res.data.item.form_picture);//将视频和图片的json转为数据
						console.log(jsonStr)
						that.$refs['form_picture'].uploadList = jsonStr;
					}
					that.pageForm = res.data.item;
					that.form_modal = true;
				}
			},
			// 删除账户
			delFormType(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delFormType(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			addFormButton(){
				this.pageForm = {};
				this.form_modal = true;
			},
			async addFormType() {
				let that = this;
				let data = {
					token: that.token,
					pageForm: that.pageForm,
				};
				data.form_picture = that.$refs['form_picture'].uploadList;
				let res = await addFormType(that, data);
				if (res.code == 1) {
					this.form_modal = false;
					this.getList();
					that.$Message.success('保存成功');
				}
			},
			search() {
				this.getList();
			}
		},


	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
